import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import { useTheme, jsx } from '@emotion/react';
import Style from './style.js';

var _excluded = ["backgroundColor", "barColor", "height", "loadingTime", "status"];
var ProgressBar = _ref => {
  var {
    backgroundColor,
    barColor,
    height = 4,
    loadingTime = '20s',
    status
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  var backgroundColorWithTheme = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.COLORS.background;
  var barColorWithTheme = barColor !== null && barColor !== void 0 ? barColor : theme.COLORS.primary;
  return jsx(Style.OuterContainer, _extends({
    status: status,
    barHeight: height,
    backgroundColor: backgroundColorWithTheme // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest), jsx(Style.InnerBar, {
    status: status,
    barHeight: height,
    barColor: barColorWithTheme,
    loadingTime: loadingTime
  }));
};

export { ProgressBar };
